import Vue from 'vue'
import ElementUI from 'element-ui'
import '@/styles/variables/element-variables.scss'
import 'element-ui/lib/theme-chalk/icon.css'

Vue.use(ElementUI, { size: 'small' })
